// import { useMutation, useQuery } from "@apollo/client";
// import { createAgendaShiftByUserId, updateAgendaShiftApplication } from "./queries";
// import { useAuthContext } from "../../../contexts/AuthContext";
// import { AgendaShiftApplication, AgendaUser, CreateAgendaShiftApplicationByUserIdMutation, CreateAgendaShiftByUserIdMutation, CreateAgendaShiftByUserIdMutationVariables, UpdateAgendaShiftApplicationMutation, UpdateAgendaShiftApplicationMutationVariables } from "../../../graphql/API";
// import { v4 as uuidv4 } from 'uuid';
// import { useNavigate } from "react-router-dom";
// import TopicNotificationService from "../TopicService";

// const useShiftApplicationService = (shiftAppId?: string, manager: boolean = false, givenDate?: string, shift?: AgendaShiftApplication, usrFCMtoken?: string) => { //(shiftId: string, commentId: string | null) => {
//     const {userId} = useAuthContext();
//     const navigate = useNavigate();

//     // const {data, refetch} = useQuery<GetPostQuery, GetPostQueryVariables>(shiftAppId, {variables: {shiftAppId: shiftAppId}});
//     const {sendTopicNotification} = TopicNotificationService();

//     const [doUpdateShiftApplication] = useMutation<UpdateAgendaShiftApplicationMutation, UpdateAgendaShiftApplicationMutationVariables>(updateAgendaShiftApplication); //,{refetchQueries: ['CommentsByPost']}); //...don't need that because of subscription
    
//     const [doCreateShift, {loading: loadingUpdate, error: errorUpdate}] = 
//         useMutation<CreateAgendaShiftByUserIdMutation, CreateAgendaShiftByUserIdMutationVariables>(createAgendaShiftByUserId);
    
//     const generateCustomId = () => {
//         const prefix = "Shift";//"ShiftApp";
//         const uniquePart = uuidv4();
//         return `${prefix}-${uniquePart}`;
//     };

//     const createShift = async () => {
//       if (shift) {
//         // console.log(shift);
//         // return
//         try {
//           const shiftId = generateCustomId();
//           await doCreateShift({
//             variables: {
//                 shiftId: shiftId,
//                 comId: shift.comId,
//                 userId: shift.userId, //dataUser?.userId, // get the selected item
//                 username: shift.username,
//                 info: shift.info,
//                 role: shift.role,
//                 location: shift.location,
//                 startAt: shift.startAt,//day+"T"+start,
//                 stopAt: shift.stopAt,//day+"T"+stop,
//                 deleted: false,
//                 accepted: false,
//                 confirmed: true,
//                 suspended: false,
//                 createdAt: new Date().toISOString(),
//                 updatedAt: new Date().toISOString()
//             }
//           });
//           // sendShiftNotification(formData.role, formData.location);
//           if (shift.userId !== userId) {
//             sendTopicNotification(shift.role ?? undefined, shift.location ?? undefined, usrFCMtoken ?? undefined, shift.userId ?? undefined, shiftId ?? undefined, shift.startAt, shift.stopAt, "confirmShift");
//           }
//           // sendShiftNotification(shift.role ?? "undefined", shift.location ?? "undefined", usrFCMtoken ?? "undefined");
    
//           // navigation.navigate('OpenApplication', {refetchShift: true});
//         } catch (error) {
//           alert("Error Creating a shift Application: " + (error as Error).message);
//           console.log((error as Error).message);
//         }
//       } else {
//         alert("Error loading shift Application Detail");
//       }
//     }

//     const onUpdateShiftApplication = async (shiftApp: AgendaShiftApplication) => {
//       console.log('sAPP',shiftAppId);
//       try {
//           console.log('sAPP',shiftAppId);
//           await doUpdateShiftApplication({
//             variables: {
//               input: {
//                 shiftAppId: shiftApp.shiftAppId,
//                 accepted: true,
//               },
//             },
//           });
//           if (manager) {
//             navigate('/sheduler/open_shifts');
//           } else {
//             // navigate('/open_shifts');
//             window.location.reload();
//           }
//       } catch(error) {
//           alert("Error Updating a shift: " + (error as Error).message);
//       };
//     };

//     const onUpdateShiftApplicationConfirm = async (shiftAppId: string) => {
//       try {
//           console.log(shiftAppId);
//           await doUpdateShiftApplication({
//             variables: {
//               input: {
//                 shiftAppId: shiftAppId,
//                 confirmed: true,
//               },
//             },
//           });
//           await createShift();
//           navigate('/sheduler');
//           // if (givenDate) {
//           //   navigate('/AgendaManager', {refetchShift: true, givenDate});
//           // } else {
//           //   navigate('/sheduler/open_shifts');
//           // } 
//       } catch(error) {
//           alert("Error Creating a shift: " + (error as Error).message);
//       };
//     };

//     return {
//       onUpdateShiftApplication, onUpdateShiftApplicationConfirm
//     };
// };

// export default useShiftApplicationService;

import { useMutation, useQuery } from "@apollo/client";
import { createAgendaShiftByUserId, updateAgendaShiftApplication } from "./queries";
import { useAuthContext } from "../../../contexts/AuthContext";
import { AgendaShiftApplication, AgendaUser, CreateAgendaShiftApplicationByUserIdMutation, CreateAgendaShiftByUserIdMutation, CreateAgendaShiftByUserIdMutationVariables, UpdateAgendaShiftApplicationMutation, UpdateAgendaShiftApplicationMutationVariables } from "../../../graphql/API";
import TopicNotificationService from "../TopicService";
import useHelperService from '../../services/HelperService';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import useDateService from "../DateService";
import { PUBLIC_ID } from "../../../config";

const useShiftApplicationService = (
  shiftApp: AgendaShiftApplication, 
  manager: boolean = false, 
  locale: string = "en", 
  givenDate?: string, 
  usrFCMtoken?: string, 
  nav?: string, 
  managers?: AgendaUser[]) => {
    // AUTH
    const {userId} = useAuthContext();
    // I18N
    const { t } = useTranslation();
    // NAVIGATION
    const navigate = useNavigate();
    // SERVICES
    const {sendTopicNotification} = TopicNotificationService();
    const {generateCustomId} = useHelperService();
    // DATE SERVICES
    const {getTIMEZONE, isNowGreater} = useDateService();
    // TIMEZONE SETTINGS
    const TIMEZONE = getTIMEZONE();
    // DB QUERIES
    const [doUpdateShiftApplication] = useMutation<UpdateAgendaShiftApplicationMutation, UpdateAgendaShiftApplicationMutationVariables>(updateAgendaShiftApplication); //,{refetchQueries: ['CommentsByPost']}); //...don't need that because of subscription
    
    const [doCreateShift, {loading: loadingUpdate, error: errorUpdate}] = 
        useMutation<CreateAgendaShiftByUserIdMutation, CreateAgendaShiftByUserIdMutationVariables>(createAgendaShiftByUserId);
    // FUNCTIONS
    const createShift = async (accepted: boolean) => {
      if (shiftApp) {
        // return
        try {
          const shiftId = generateCustomId("Shift");
          await doCreateShift({
            variables: {
                shiftId: shiftId,
                shiftAppId: shiftApp.shiftAppId,
                comId: shiftApp.comId,
                userId: shiftApp.userId,
                username: shiftApp.username,
                lat: shiftApp.lat,
                lng: shiftApp.lng,
                info: shiftApp.info,
                role: shiftApp.role,
                location: shiftApp.location,
                startAt: shiftApp.startAt,
                stopAt: shiftApp.stopAt,
                deleted: false,
                accepted: accepted,
                confirmed: true,
                suspended: false,
                createdAt: new Date().toISOString(),
                updatedAt: new Date().toISOString()
            }
          });
          // sendShiftNotification(formData.role, formData.location);
          const alreadyDone = isNowGreater(new Date(shiftApp.stopAt), TIMEZONE);
          if (!alreadyDone) {
            if (shiftApp.userId !== userId) {
              sendTopicNotification(shiftApp.role ?? undefined, shiftApp.location ?? undefined, usrFCMtoken ?? undefined, shiftApp.userId ?? undefined, shiftId ?? undefined, shiftApp.startAt, shiftApp.stopAt, "confirmShift");
            }
          }
          // sendShiftNotification(shift.role ?? "undefined", shift.location ?? "undefined", usrFCMtoken ?? "undefined");
    
          // navigation.navigate('OpenApplication', {refetchShift: true});
        } catch (error) {
          alert("Error Creating a shift Application: " + (error as Error).message);
          console.log((error as Error).message);
        }
      } else {
        alert("Error loading shift Application Detail");
      }
    }

    const createAcceptShift = async (usrId: string, username: string) => {
      if (shiftApp) {
        // return
        try {
          const shiftId = generateCustomId("Shift");
          await doCreateShift({
            variables: {
                shiftId: shiftId,
                shiftAppId: shiftApp.shiftAppId,
                comId: shiftApp.comId,
                userId: usrId,
                username: username,
                lat: shiftApp.lat,
                lng: shiftApp.lng,
                info: shiftApp.info,
                role: shiftApp.role,
                location: shiftApp.location,
                startAt: shiftApp.startAt,
                stopAt: shiftApp.stopAt,
                deleted: false,
                accepted: true,
                confirmed: false,
                suspended: false,
                createdAt: new Date().toISOString(),
                updatedAt: new Date().toISOString()
            }
          });
          // sendShiftNotification(formData.role, formData.location);
          // const alreadyDone = isNowGreater(new Date(shiftApp.stopAt ?? ""), TIMEZONE);
          // if (!alreadyDone) {
          //   if (usrId !== userId) {
          //     sendTopicNotification(shiftApp.role ?? undefined, shiftApp.location ?? undefined, usrFCMtoken ?? undefined, usrId ?? undefined, shiftId ?? undefined, shiftApp.startAt, shiftApp.stopAt, "confirmShift");
          //   }
          // }
          return shiftId;
        } catch (error) {
          alert("Error Creating a shift" + ": " + (error as Error).message);
          console.log((error as Error).message);
        }
      } else {
        alert("Error loading shift Application Detail");
      }
    }

    const onUpdateShiftApplicationAccept = async (usrId: string, username: string) => {
      try {
        if (shiftApp.userId != PUBLIC_ID) {
          await doUpdateShiftApplication({
            variables: {
              input: {
                shiftAppId: shiftApp.shiftAppId,
                accepted: true,
              },
            },
          });
        }
        const shiftId = await createAcceptShift(usrId, username);
        if (shiftId) {
          const alreadyDone = isNowGreater(new Date(shiftApp.stopAt ?? ""), TIMEZONE);
          if (!alreadyDone) {
            managers?.forEach(manager => {
              // if (manager?.FCMtoken) {
                if (manager?.userId != userId) {
                    sendTopicNotification(shiftApp.role ?? undefined, shiftApp.location ?? undefined, manager?.FCMtoken ?? undefined, manager.userId ?? undefined, shiftApp.shiftAppId ?? undefined, shiftApp.startAt, shiftApp.stopAt, "shiftAccepted");
                }
              // }
            });
          }
          // if (manager) {
          //   if (nav === "OpenShiftDetail") {
          //     navigate('OpenShiftDetail', {shiftAppId: shiftApp.shiftAppId, refetchShift: true});
          //   } else {
          //     navigation.navigate('AgendaManager', {refetchShift: true, givenDate});
          //   }
          // } else {
          //   if (nav === "OpenShiftDetail") {
          //     navigate('OpenShiftDetail', {shiftAppId: shiftApp.shiftAppId, refetchShift: true});
          //   } else {
          //     navigate('Shift', {refetchShift: true});
          //     navigate('/shifts', { replace: true, state: { refetchData: true } });
          //   }
          // }
          navigate('/shifts', { replace: true, state: { refetchData: true } });
        }
      } catch(error) {
          alert(t('shift.errorAcceptingShift') + ": " + (error as Error).message);
      };
    };

    // const onUpdateShiftApplicationAccept = async () => {
    //   try {
    //       await doUpdateShiftApplication({
    //         variables: {
    //           input: {
    //             shiftAppId: shiftApp.shiftAppId,
    //             accepted: true,
    //           },
    //         },
    //       });

    //       const alreadyDone = isNowGreater(new Date(shiftApp.stopAt), TIMEZONE);
    //       if (!alreadyDone) {
    //         managers?.forEach(manager => {
    //           // if (manager?.FCMtoken) {
    //             if (manager?.userId != userId) {
    //               console.log('id:', manager.username)
    //               // if (manager?.userId == "f418b408-d0a1-70a9-df3a-61b0a6e1ff9a") {
    //               sendTopicNotification(shiftApp.role ?? undefined, shiftApp.location ?? undefined, manager?.FCMtoken ?? undefined, manager.userId ?? undefined, shiftApp.shiftAppId ?? undefined, shiftApp.startAt, shiftApp.stopAt, "openShiftAccepted");
    //               // }
    //             }
    //           // }
    //         });
    //       }
    //       navigate('/open_shifts', { replace: true, state: { refetchData: true } });
    //   } catch(error) {
    //       alert(t('shift.errorAcceptingShift') + ": " +  (error as Error).message);
    //   }
    // };

    const onUpdateShiftApplicationConfirm = async () => {
      try {
          await doUpdateShiftApplication({
            variables: {
              input: {
                shiftAppId: shiftApp.shiftAppId,
                confirmed: true,
              },
            },
          });
          await createShift(shiftApp?.accepted ?? false);
          navigate(`/shifts/${shiftApp.shiftAppId}`);
          // } 
      } catch(error) {
          alert(t('shift.errorConfirmedShift') + ": " + (error as Error).message);
      };
    };

    const onDeleteShiftApplication = async () => {
        try {
          await doUpdateShiftApplication({
            variables: {
              input: {
                shiftAppId: shiftApp.shiftAppId,
                deleted: true,
              }
            }
          });
          navigate(`${t('link.scheduler')}${t('link.open_shifts')}`, { replace: true, state: { refetchData: true } });
        } catch(error) {
          alert(t('shift.errorDeletedShift') + ": " + (error as Error).message);
        }
      }

    return {
      onUpdateShiftApplicationAccept, onUpdateShiftApplicationConfirm, onDeleteShiftApplication
    };
};

export default useShiftApplicationService;